import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    preselected: String,
    url: String,
    excludeIds: String
  }

  connect() {
    const input = this.element.querySelector('[data-selectize-supplier-typeahead-target="input"]')

    if (input) {
      this.initializeSelectize(input)
    }
  }

  disconnect() {
    if (this.selectize) {
      this.selectize.destroy()
    }
  }

  initializeSelectize(input) {
    const preselectedData = this.preselectedValue ? JSON.parse(this.preselectedValue) : []
    const searchUrl = this.urlValue || '/admin/suppliers/search'
    const excludeIds = this.hasExcludeIdsValue ? JSON.parse(this.excludeIdsValue) : []

    $(input).selectize({
      plugins: ['remove_button'],
      valueField: 'id',
      labelField: 'name',
      searchField: 'name',
      placeholder: input.placeholder,
      create: false,
      maxItems: null,
      preload: false,
      options: preselectedData,
      items: preselectedData.map(item => item.id),
      load: (query, callback) => {
        if (!query.length) return callback()

        $.ajax({
          url: searchUrl,
          type: 'GET',
          dataType: 'json',
          data: { q: query },
          error: () => {
            callback()
          },
          success: (data) => {
            // Filter out excluded supplier IDs
            const filteredData = data.filter(supplier => !excludeIds.includes(supplier.id))
            callback(filteredData)
          }
        })
      },
      render: {
        option: (item, escape) => {
          return `<div><strong>${escape(item.name)}</strong></div>`
        },
        item: (item, escape) => {
          return `<div>${escape(item.name)}</div>`
        }
      }
    })

    this.selectize = input.selectize
  }
}
